module.exports = __webpack_public_path__ + "media/images/sp/stores/fukuoka/fukuoka_sns_04-e210a2987ebf2fb2623bfc7044e30eb9.jpg";